(function () {
    'use strict';
    var serviceId = 'repository.servicetimeshipper';
    angular
        .module('app.services')
        .factory(serviceId, serviceTimeShipper);

        serviceTimeShipper.$inject = ['common', 'repository.abstract', '$http'];

    function serviceTimeShipper(common, abstractRepository, $http) {
        var config = common.config;

        function Ctor(mgr) {
            this.manager = mgr;
            this.getServiceTimeShipperList = getServiceTimeShipperList;
            this.getTransactionTypes = getTransactionTypes;
        }

        abstractRepository.extend(Ctor);
        return Ctor;


        function getServiceTimeShipperList(model) {
            return common.httpPost(config.basePaths.Base_Path_Resources + 'reportList/GetServiceTimeShipper', model);
        }

        function getTransactionTypes(){
            return common.httpPost(config.basePaths.Base_Path_Resources + 'reportList/GetTransactionTypes', null);
        }
    }

})();
